import React from "react";
import ButtonBlock from "./ButtonBlock";
import ImageBlock from "./ImageBlock";
import QuoteBlock from "./QuoteBlock";
import SeparatorBlock from "./SeparatorBlock";
import TextBlock from "./TextBlock";
import VideoBlock from "./VideoBlock";
import VistityBlock from "./VistityBlock";

export {
  ButtonBlock,
  ImageBlock,
  QuoteBlock,
  SeparatorBlock,
  TextBlock,
  VideoBlock,
  VistityBlock
};

const BLOCK_MAP = {
  Button: ButtonBlock,
  Image: ImageBlock,
  Quote: QuoteBlock,
  Separator: SeparatorBlock,
  Text: TextBlock,
  Video: VideoBlock,
  Vistity: VistityBlock
};

const Block = ({ block }) => {
  const Component = BLOCK_MAP[block.blockType];
  return <Component block={block} />;
};

export default Block;



// WEBPACK FOOTER //
// ./src/components/Blocks/index.js